// src/theme/tokens/chart.js
// Faz 1 · Konsolide chart/data viz semantic tokens.
// Mevcut chartPrimary/Secondary + mentorChart* ikiligi Faz 4'te
// bu yeni 'chart.*' namespace'ine alias ile baglanir.
// Cizim kutuphanesinden bagimsiz (Chart.js, Recharts, vb.) kullanilabilir.

const chartTokens = {
  // ===== SERI RENKLERI (kategorisel, 8 seri'ye kadar) =====
  'chart.series.1': { default: 'brand.500',  _dark: 'brand.300' },     // Birincil mavi
  'chart.series.2': { default: 'indigo.500', _dark: 'indigo.300' },    // Ikincil mor-mavi
  'chart.series.3': { default: 'teal.500',   _dark: 'teal.300' },      // Klinik teal
  'chart.series.4': { default: 'amber.500',  _dark: 'amber.300' },     // Sicak vurgu
  'chart.series.5': { default: 'rose.500',   _dark: 'rose.300' },      // Kontrast pembe
  'chart.series.6': { default: 'emerald.500', _dark: 'emerald.300' },  // Yesil
  'chart.series.7': { default: '#7C3AED',    _dark: '#A78BFA' },       // Mor (purple.600/400)
  'chart.series.8': { default: 'slate.500',  _dark: 'slate.400' },     // Notr

  // ===== SERI ARKA PLAN (alpha varyantlari, alan grafikleri icin) =====
  'chart.series.1.bg': { default: 'brand.500_alpha_15',  _dark: 'brand.300_alpha_20' },
  'chart.series.2.bg': { default: 'indigo.500_alpha_15', _dark: 'indigo.300_alpha_30' },
  'chart.series.3.bg': { default: 'teal.500_alpha_15',   _dark: 'teal.300_alpha_30' },
  'chart.series.4.bg': { default: 'amber.500_alpha_15',  _dark: 'amber.300_alpha_30' },
  'chart.series.5.bg': { default: 'rose.500_alpha_15',   _dark: 'rose.300_alpha_30' },
  'chart.series.6.bg': { default: 'emerald.500_alpha_15', _dark: 'emerald.300_alpha_30' },

  // ===== DIVERGING (pozitif/negatif/notr · performans grafikleri) =====
  'chart.diverging.positive':   { default: 'emerald.500', _dark: 'emerald.300' },
  'chart.diverging.positiveBg': { default: 'emerald.500_alpha_15', _dark: 'emerald.300_alpha_30' },
  'chart.diverging.negative':   { default: 'rose.500',    _dark: 'rose.300' },
  'chart.diverging.negativeBg': { default: 'rose.500_alpha_15', _dark: 'rose.300_alpha_30' },
  'chart.diverging.neutral':    { default: 'slate.400',   _dark: 'slate.500' },
  'chart.diverging.neutralBg':  { default: '#E2E8F0',     _dark: '#4A5568' },

  // ===== HEAT (yogunluk haritalari, contribution graph) =====
  // 'chart.heat.0..4' tokenlari kaldirildi (sifir kullanim · contribution graph
  // bilesenleri henuz uretilmedi). Yeniden gerekirse git history'den geri getirilir.

  // ===== AXIS / GRID / GUIDE =====
  'chart.grid':       { default: 'rgba(15, 20, 25, 0.06)', _dark: 'rgba(255, 255, 255, 0.08)' },
  'chart.gridStrong': { default: 'rgba(15, 20, 25, 0.12)', _dark: 'rgba(255, 255, 255, 0.15)' },
  'chart.axis':       { default: 'slate.500', _dark: 'slate.400' },
  'chart.axisLabel':  { default: 'slate.600', _dark: 'slate.300' },
  'chart.axisTitle':  { default: 'slate.700', _dark: 'slate.200' },

  // ===== TOOLTIP =====
  'chart.tooltip.bg':     { default: 'white',     _dark: 'slate.800' },
  'chart.tooltip.border': { default: 'slate.200', _dark: 'slate.700' },
  'chart.tooltip.text':   { default: 'slate.800', _dark: 'slate.50' },
  'chart.tooltip.shadow': { default: '0 4px 12px rgba(15,20,25,0.12)', _dark: '0 4px 12px rgba(0,0,0,0.6)' },

  // ===== POINT / MARKER =====
  'chart.point.border': { default: 'white', _dark: 'slate.800' },
  'chart.point.bg':     { default: 'brand.500', _dark: 'brand.300' },
  'chart.point.hover':  { default: 'brand.600', _dark: 'brand.200' },

  // ===== CANVAS / SURFACE =====
  'chart.canvas.bg':     { default: 'transparent', _dark: 'transparent' },
  'chart.canvas.border': { default: 'slate.100', _dark: 'slate.800' },

  // ===== LEGEND =====
  'chart.legend.text':   { default: 'slate.600', _dark: 'slate.300' },
  'chart.legend.bg':     { default: 'transparent', _dark: 'transparent' },
};

// JS array · chart.js datasets icin convenience export.
// import { CHART_SERIES } from 'theme/tokens/chart';
const CHART_SERIES = [
  'chart.series.1',
  'chart.series.2',
  'chart.series.3',
  'chart.series.4',
  'chart.series.5',
  'chart.series.6',
  'chart.series.7',
  'chart.series.8',
];

export default chartTokens;
export { CHART_SERIES };
